import React from 'react';
import {Route} from 'react-router';
import localization from '../localization/index';
import AuthRedirect from '../views/auth/authRedirect';
import AuthLogout from '../views/auth/authLogout';

const KEY = 'cognito';
const NAME = 'COGNITO';

const routes = [
	<Route
		exact
		path={'/publics/cognito/callback'}
		key={KEY + 'AuthCallback'}
		components={AuthRedirect}
		hideTemplate
	/>,

	<Route
		exact
		path={'/publics/cognito/logout'}
		key={KEY + 'AuthLogout'}
		components={AuthLogout}
		hideTemplate
	/>
];

const Module = {
	name: NAME,
	key: KEY,
	icon: null,
	portlets: [],
	menu: {},
	routes,
	localization
};

export default Module;
